import React from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';
import CardContent from '@material-ui/core/CardContent';
import { makeStyles } from '@material-ui/core/styles';
import { Divider } from '@material-ui/core';

// import { isMobile } from 'react-device-detect';


const useStyles = makeStyles(theme => ({

    textocabecera : {
        color : '#009aa8',
        fontSize: '180%',
        fontFamily: 'Ubuntu',
        fontWeight: 'bold'
    },
    textovalor : {
        color : '#1a1919',
        fontSize: '350%',
        textAlign: "left",
        fontFamily: 'Ubuntu',
        fontWeight: 'bold'
    },
    textovalorreduce : {
        color : '#1a1919',
        fontSize: '200%',
        textAlign: "left",
        fontFamily: 'Ubuntu',
        fontWeight: 'bold'
    },
    textotitulodetalle : {
        color : '#1a1919',
        fontSize: '100%',
        maxWidth: '100%',
        fontFamily: 'Ubuntu',
        fontWeight: 'bold'
    },
    textotitulodetallenegrita : {
        color : '#009aa8',
        fontSize: '100%',
        fontFamily: 'Ubuntu',
        fontWeight: 'bold'
    },
    texttitleone : {
        color : '#1a1919',
        fontSize: '100%',
        fontFamily: 'Ubuntu',
        fontWeight: 'bold'
    },
    line: {
        backgroundColor: '#009aa8',
        height: '1px',
        width: '100%'
    },
    fondotexto: {
        backgroundColor: 'white'
    },
    submit: {
        [theme.breakpoints.up('xs')]: {
            fontSize: '0.6rem',
            color: '#1a1919',
            borderRadius: '0px',
            borderLeft: '3px solid rgba(255, 198, 0)',
            backgroundColor: "white",
            fontFamily: 'Ubuntu',
            fontWeight: 'bold'
        },
        [theme.breakpoints.up('sm')]: {
            fontSize: '0.6rem',
            color: '#1a1919',
            borderLeft: '3px solid rgba(255, 198, 0)',
            backgroundColor: "white",
            fontFamily: 'Ubuntu',
            fontWeight: 'bold'
        },
        [theme.breakpoints.up('md')]: {
            fontSize: '0.6rem',
            color: '#1a1919',
            borderLeft: '3px solid rgba(255, 198, 0)',
            backgroundColor: "white",
            fontFamily: 'Ubuntu',
            fontWeight: 'bold'
        },
        [theme.breakpoints.up('lg')]: {
            fontSize: '0.6rem',
            color: '#1a1919',
            borderLeft: '3px solid rgba(255, 198, 0)',
            backgroundColor: "white",
            fontFamily: 'Ubuntu',
            fontWeight: 'bold'
        },
        [theme.breakpoints.up('xl')]: {
            fontSize: '0.6rem',
            color: '#1a1919',
            borderLeft: '3px solid rgba(255, 198, 0)',
            backgroundColor: "white",
            fontFamily: 'Ubuntu',
            fontWeight: 'bold'
        },
    }
}));

const Voucher = props => {

    const classes = useStyles();

    const {
            amount,
            titleheader,
            databodyone,
            title,
            handleDownloadVoucher,
            // handleDownloadDevice,
            textButtonCancel,
            handleCancel
    } = props;

    return (
        <div>
            <Card elevation={0}>

                <CardContent>

                    <Grid container spacing={3}>
                        <Grid item xs={12} md={12}>
                            <Typography component="h1" variant="h1" className = { classes.textocabecera } align = "left">
                                { title }
                            </Typography>
                            <br/>
                            <Typography component="h1" variant="h1" className = { classes.texttitleone } align = "left">
                                { titleheader }
                            </Typography>
                            <br/>
                            <Typography component="h1" variant="h1" className = { (amount < 1000) ? classes.textovalor : classes.textovalorreduce } align = "left">
                                $ { parseFloat(amount).toFixed(2) }
                            </Typography>
                        </Grid>

                    </Grid>
                    <br/><br/>
                    <Grid container spacing={3} alignItems="center" direction="row" justify="center">

                        <Grid item xs={12} md={12}>

                            {
                                databodyone.map(row => (
                                    <Grid container spacing={3} key = {row.order}>
                                        <Grid item xs={6} md={6} >
                                            <Typography component="p" variant="body1" className = { classes.textotitulodetallenegrita } align="justify">
                                                <b>{row.title}</b>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={6} md={6} >
                                            <Typography component="p" variant="body1" className = {classes.textotitulodetalle} align="justify" noWrap = { (typeof row.value === "string") ? (row.value.indexOf(" ") > 0) ? false : true : true}>
                                                { row.value }
                                            </Typography>
                                        </Grid>
                                        <br />
                                        <Divider className = {classes.line}/>
                                        <br />

                                    </Grid>
                                ))
                            }

                        </Grid>

                        <br />
                        <br />


                            <Grid item xs={6} md={6} sm = {6}>
                                <Button
                                    size="small"
                                    fullWidth
                                    onClick={ handleDownloadVoucher }
                                    variant="contained"
                                    className={classes.submit}
                                    > Imprimir</Button>
                            </Grid>
                                    {/* { (!isMobile) && 
                        }
                        { (isMobile) &&

                        <Grid item xs={6} md={6} sm = {6}>
                            <Button
                                size="small"
                                fullWidth
                                onClick={ handleDownloadDevice }
                                variant="contained"
                                className={classes.submit}
                            > Compartir</Button>
                        </Grid>
                    } */}

                    <Grid item xs={6} md={6} sm = {6}>
                            <Button
                                size="small"
                                fullWidth
                                onClick={ handleCancel }
                                variant="contained"
                                className={classes.submit}
                            > {textButtonCancel}</Button>
                        </Grid>
                    </Grid>
                </CardContent>

            </Card>
        </div>
    );
}



export default Voucher;
